import './styles/tabs.less';
import React from 'react';
import { connect } from 'dva';
import { Layout, Tabs, Dropdown, Button, Menu, Icon } from 'antd';
import BaseComponent from './BaseComponent';
import { Switch, Route } from 'dva/router';
import P404 from '../basic/Pages/404';
import store from 'store2';
import { framework_tool } from '@/tool'
const { modelUtils } = framework_tool

const NotFound = P404
const { Content } = Layout;
const TabPane = Tabs.TabPane;

function getTitle(pathName) {
  const map = window.dva_router_pathMap[pathName];
  return <div className="tab-title">{map ? map.title : 'Tag'}</div>;
}

class TabsLayout extends BaseComponent {
  constructor(props) {
    const {
      location: { pathname }
    } = props;
    super(props);
    this.state = {
      
    }
  }

  componentWillReceiveProps(nextProps) {

  }

  // 拼装面包屑tabs对应的数据模板
  initTabs() {
    let { tablayoutModels = {}, childRoutes } = this.props
    let { data = [] } = tablayoutModels
    let allTabs = data?.map((f, i) => {
      let router = childRoutes.filter(item => item.key === f.pathname);
      return router
    }).flat(Infinity)
    return allTabs
  }

  componentWillUnmount() {
    store.session.remove('searchMap')
  }

  // 将tabs内容放置redux
  _initModelVal(data) {
    this.props.dispatch({
      type: 'tablayoutModels/setTopBar',
      payload: {
        ...data
      }
    })
  }

  /**
     * 清除searchBar缓存
     */
  _cacheClear() {
    const _key = window.location.hash
    const _searchMap = store.session('searchMap') || []
    const _index = _searchMap.findIndex(val => val.key === _key)

    if (_index !== -1) {
      _searchMap[_index].value = {}
      store.session('searchMap', _searchMap)
    }
  }

  onChange = activeKey => {
    this.changed = true
    this.history.push(activeKey);
  };

  onRemove = targetKey => {
    let { activeKey, data: panes } = this.props.tablayoutModels;
    let lastIndex;
    panes.forEach((pane, i) => {
      if (pane.pathname === targetKey) {
        lastIndex = i - 1;
      }
    });
    const newpanes = panes.filter(pane => pane.pathname !== targetKey);
    let newKey = activeKey;
    if (newpanes.length && activeKey === targetKey) {
      newKey = lastIndex >= 0 ? newpanes[lastIndex].pathname : newpanes[0].pathname;
    }
    //更新tabs
    this._initModelVal({
      data: newpanes,
      activeKey: newKey
    })
    // 是否需要重新跳转
    if (newKey !== targetKey) this.onChange(newKey);
    if (newpanes.length === 0 && lastIndex < 0) {
      this.onChange('/home')
      // newpanes = [{ pathname: '/home' }]
      // newKey = '/home'
    }
    this._cacheClear()
  };

  onRemoveOther = () => {
    let { activeKey, data: panes } = this.props.tablayoutModels;
    const newpanes = panes.filter(pane => pane.pathname === activeKey);
    this._initModelVal({
      data: newpanes
    })
  };

  onRemoveAll = () => {
    let { initMenu } = this.props
    initMenu && initMenu()
    this._initModelVal({
      data: [{ pathname: '/home' }],
      activeKey: '/home'
    })
    this.onChange('/home')
    this._cacheClear()
  };

  onTabsActions = ({ key }) => {
    let { activeKey } = this.props.tablayoutModels;
    switch (key) {
      case 'close':
        this.onRemove(activeKey);
        break;
      case 'closeother':
        this.onRemoveOther();
        break;
      case 'closeall':
        this.onRemoveAll();
        break;
      default:
        break;
    }
  };

  // 如果木有这个路由
  isUnRouter() {
    let { tablayoutModels = {}, childRoutes } = this.props
    const { activeKey } = tablayoutModels
    return !childRoutes.some(i => i.key == activeKey)
  }



  render() {
    let { tablayoutModels = {} } = this.props
    const { activeKey } = tablayoutModels

    return (
      <Layout className="full-layout tabs-layout">
        <Content>
          <Switch>
            {this.isUnRouter() ? (
              <Route component={NotFound} />
            ) : (
              <Tabs
                // key={key}
                animated={false}
                hideAdd
                type="editable-card"
                className="lanif-tabs-content"
                tabBarExtraContent={
                  <Dropdown
                    overlay={
                      <Menu onClick={this.onTabsActions}>
                        <Menu.Item key="close">关闭当前</Menu.Item>
                        <Menu.Item key="closeother">关闭其它</Menu.Item>
                        <Menu.Item key="closeall">关闭所有</Menu.Item>
                      </Menu>
                    }
                  >
                    <Button type="primary" ghost>
                      操作
                      <Icon type="down" />
                    </Button>
                  </Dropdown>
                }
                onEdit={this.onRemove}
                onChange={this.onChange}
                activeKey={activeKey}
              >
                {this.initTabs().map(item => (
                  <TabPane style={{ backgroundColor: '#F0F2F5', padding: 15 }} tab={getTitle(item.key)} key={item.key}>
                    {item}
                  </TabPane>
                ))}
              </Tabs>
            )}
          </Switch>
        </Content>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { tablayoutModels } = state;
  return {
    tablayoutModels
  };
};

export default connect(mapStateToProps)(TabsLayout);